// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
window.commonLogan = require('./request/loganMethod').commonLogan;
import apis from './request/apis';
import './commonjs/vuePrototype.js';
import './iconfont/iconfont.js';
import { NavBar, Dialog, Toast, Popup, Progress, Button, Icon } from 'vant';
import store from './vuex/store';
window.commonObj = require('@/commonjs/common.js').commonObj;
window.utilsObj = require('@/commonjs/utils.js').utilsObj;
window.uploadFileObj = require('@/commonjs/uploadFile.js').uploadFileObj;
import VuePageStack from 'vue-page-stack';
import APlayer from '@moefe/vue-aplayer';
import Meta from 'vue-meta';
import VConsole from 'vconsole';
import LoadingPlugin from './components/ComLoading/userLoading.js';
import wx from 'weixin-js-sdk';

//开发工具
const isProd = process.env.NODE_ENV === 'production';
if (!isProd && location.pathname != '/visualPark') {
  const vConsole = new VConsole();
  Vue.use(vConsole);
}

// 完整加载
import VueLuckyCanvas from '@lucky-canvas/vue';
Vue.use(VueLuckyCanvas);

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$api = apis;
Vue.prototype.$wx = wx;
Vue.use(Icon);
Vue.use(Button);
Vue.use(Progress);
Vue.use(Meta);
Vue.use(NavBar);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(LoadingPlugin);
Vue.use(VuePageStack, { router });
Vue.use(APlayer, {
  defaultCover: '',
  productionTip: true
});

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js